import { logoutState } from '@/app/_auth/logout-state'
import { dropdownItemClass } from '@/components/navbar-next/'
import { useUploadableDocumentTypes } from '@/helpers/permission-helpers'
import { useAuthContext } from '@/hooks/use-auth-context'
import { Button, Loader, Menu } from '@mantine/core'
import { signOutOfCognito } from '@/app/_auth/sign-out'
import Link from 'next/link'
import { Icon } from '@/components/icon'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'

interface UserButtonProps {
  firstName: string
  lastName: string
  role: string
  orgName: string
  setFileUploadModal: React.Dispatch<React.SetStateAction<boolean>>
}

export function UserButton({
  firstName,
  lastName,
  role,
  orgName,
  setFileUploadModal
}: UserButtonProps) {
  const { session } = useAuthContext()
  const canUploadFiles = useUploadableDocumentTypes().length > 0

  if (!session || !firstName || !lastName || !role || !orgName)
    return <Loader size="sm" />

  return (
    <Menu shadow="md" width={200}>
      <Menu.Target>
        <Button
          data-testid="user-menu-trigger"
          variant="transparent"
          c="white"
          rightSection={<Icon icon={faChevronDown} size={10} />}
        >
          {firstName} {lastName}
        </Button>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Label>
          {role} @ {orgName}
        </Menu.Label>
        <Menu.Divider />
        <Menu.Item
          component={Link}
          href="/profile"
          className={dropdownItemClass}
        >
          Profile
        </Menu.Item>
        <Menu.Item component={Link} href="/tasks" className={dropdownItemClass}>
          Tasks
        </Menu.Item>

        {canUploadFiles && (
          <Menu.Item
            className="flex w-[100%] rounded-md text-sm font-medium whitespace-nowrap text-[var(--mantine-color-celerityBrand-9)] hover:text-[var(--mantine-color-celerityBrand-5)]"
            onClick={() => setFileUploadModal(true)}
          >
            Upload a File
          </Menu.Item>
        )}

        <Menu.Item
          className="flex w-[100%] rounded-md text-sm font-medium whitespace-nowrap text-[var(--mantine-color-celerityBrand-9)] hover:text-[var(--mantine-color-celerityBrand-5)]"
          onClick={() => logout()}
        >
          Sign Out
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  )
}

const logout = async () => {
  // Show the loading state instead of the sign-in page while we tear down and
  // redirect to Cognito — avoids a broken-logo flash from the aborted image
  // request on the momentarily-rendered sign-in page.
  logoutState.active = true

  localStorage.removeItem('impactReportCriteria')
  localStorage.removeItem('hasLoggedIn')

  await signOutOfCognito()
}
